/* components/LoadMore */

/*
    The LoadPrevious component is based on the LoadMore component.
    It emits an event that lets any LoadMore component on the page
    know that more items have been loaded.
*/

import { Component, Ref, Prop, SimpleEvent } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";
import axios from 'axios';

@Component
export class LoadPrevious extends ThemeComponent {

    @Prop() currentPage!: number;
    @Prop() paginateUrl!: string;
    @Prop({ default: '' }) activeFilters!: string;
    @Prop({ default: '' }) activeSorting!: string;
    @Prop() text!: string;
    @Prop() loadingText!: string;
    @Prop() pageSize!: number;
    @Prop() itemContainerSelector!: string;
    @Prop() itemSelector!: string;
    @Ref() button!: HTMLButtonElement;

    private itemContainer!: HTMLElement|null;
    private _onPreviousLoad = new SimpleEvent<string>();

    public get onPreviousLoad() {
        return this._onPreviousLoad.asEvent();
    }

    init() {
        this.itemContainer = document.querySelector(this.itemContainerSelector);
        // Listen for clicks
        this.$listen(this, 'click', () => {
            // Set loading text
            this.button.innerHTML = this.loadingText;
            // Load previous
            this.loadPrevious();
        });
    }

    loadPrevious() {
        // Make request for the previous page
        if (this.paginateUrl) {
            let url = `${this.paginateUrl}?page=${this.currentPage - 1}`;

            // If there is an active sort by option (passed as prop), then include this in the next page request
            if (this.activeSorting != '') {
                url = `${url}&sort_by=${this.activeSorting}`;
            }

            // If there are any active filters (passed as prop), then include this in the next page request
            if (this.activeFilters !== '') {
                url = `${url}&${this.activeFilters}`;
            }

            axios.get(url).then((response) => {

                // Get new elements from response data and add them to a new elements wrapper
                const newElementsWrapper = document.createElement('div');
                newElementsWrapper.innerHTML = response.data;

                // Update the current page
                this.currentPage --;

                // Add new elements to page
                const newElements = [...newElementsWrapper.querySelectorAll(this.itemSelector)].reverse();
                this.addNewElements(newElements, 'previous');

                // Dispatch an event for any components that need to update
                this.reducePaginationStart();

                // Update page query string in URL
                const url = new URL(String(window.location));
                url.searchParams.set('page', String(this.currentPage));
                window.history.pushState(null, '', url.toString());

                // If the current page is page 1, hide the load previous button
                if (this.currentPage == 1) {
                    this.button.style.display = 'none';
                }

            }).catch((error) => {
                this.$log.error('Pagination', error);
            });
        }
    }

    reducePaginationStart() {
        // Load More components, or some other components, may
        // display the current number of items loaded etc
        // Here we have a method they can subscribe to and
        // act accordingly
        this._onPreviousLoad.dispatch(String(this.pageSize));

    }

    addNewElements(elements: Element[], direction: string|null) {
        // Loop through each new element
        for (const element of elements) {

            // Check for preload attributes - update image src's
            if (element.querySelector('[data-preload]')) {
                const preloads = element.querySelectorAll('[data-preload]');
                for (const p of preloads) {
                    p.setAttribute('src', String(p.getAttribute('data-preload')));
                    p.removeAttribute('data-preload');
                }
            }

            // Add new element to the DOM
            if (this.itemContainer) {
                this.itemContainer.insertAdjacentElement('afterbegin', element);
            }

            // Update button text
            this.button.innerHTML = this.text;
        }
    }

}
